export const regex = (value, expression) => {
  if (!(expression instanceof RegExp)) {
    throw new Error('Invalid argument')
  }

  if (!value || value === '') {
    return true
  }

  return expression.test(value)
}
